var scrpts_loadd = false

function f() {
  if (!scrpts_loadd) {
    obsrvr.disconnect()
    scrpts_loadd = true
    document.querySelectorAll('iframe.lazy').forEach(g => {
      let h = g.dataset.src
      if (h !== null) g.src = h
    })

    let i = document.getElementsByTagName('script')
    for (let j = 0; j < i.length; j++) {
      if (i[j].getAttribute('data-src') !== null) {
        i[j].setAttribute('src', i[j].getAttribute('data-src'))
        delete i[j].dataset.src
      }
      if (i[j].getAttribute('type') === 'text/lazy') {
        let k = document.createElement('script')
        for (let l = 0; l < i[j].attributes.length; l++) {
          let m = i[j].attributes[l]
          k.setAttribute(m.name, m.value)
        }
        k.type = 'text/javascript'
        k.innerHTML = i[j].innerHTML
        i[j].parentNode.removeChild(i[j])
        i[j].parentNode.insertBefore(k, i[j])
      }
    }

    let n = document.getElementsByTagName('link')
    for (let j = 0; j < n.length; j++)
      if (n[j].getAttribute('data-href') !== null) {
        n[j].setAttribute('href', n[j].getAttribute('data-href'))
        delete n[j].dataset.href
      }

    document.dispatchEvent(new CustomEvent('z'))
  }
}

var usractvt = [
  'scroll',
  'mousedown',
  'mousemove',
  'keydown',
  'touchstart',
  'click',
  'keypress',
  'touchmove'
]

usractvt.forEach(p => {
  window.addEventListener(p, f, false)
})

window.addEventListener
  ? window.addEventListener('load', function () {}, false)
  : window.attachEvent
  ? window.attachEvent('onload', function () {})
  : (window.onload = p => {})
